var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareSafari(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1 1.15c.26-0.26 .68-0.26 .94 0l3.98 3.98c.26 .26 .26 .68 0 .94c-0.26 .26-0.68 .26-0.94 0l-2.85-2.85v12.35c0 .36-0.3 .66-0.66 .66c-0.37 0-0.67-0.3-0.67-0.66v-12.35l-2.85 2.85c-0.26 .26-0.68 .26-0.94 0c-0.26-0.26-0.26-0.68 0-0.94l3.99-3.98Z",
    fill: "#3478f6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32 8.92c-1.1 0-1.99 .9-1.99 2v10.76c0 1.1 .89 1.99 1.99 1.99h12.36c1.1 0 1.99-0.89 1.99-1.99v-10.76c0-1.1-0.89-2-1.99-2h-3.23v-1.33h3.23c1.83 0 3.32 1.49 3.32 3.33v10.76c0 1.83-1.49 3.32-3.32 3.32h-12.36c-1.83 0-3.32-1.49-3.32-3.32v-10.76c0-1.84 1.49-3.33 3.32-3.33h3.23v1.33h-3.23Z",
    fill: "#3478f6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSafari);
export default __webpack_public_path__ + "static/media/share-safari.72dec9ab650bc230b5ef47e386c835ac.svg";
export { ForwardRef as ReactComponent };